<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './assets/custom.scss'
import Vue from 'vue'
export default Vue.extend({
  name: "App"
})
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lato&family=Montserrat&display=swap');



#app {
  font-family: 'Lato', sans-serif;
  color: rgb(81, 81, 81);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

</style>
